import MdaeDrawer from "./component";
import { IDrawerOptions } from "devextreme-react/drawer";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeDrawerOption extends IDrawerOptions {
  id: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export default MdaeDrawer;
